// @flow
export default class Asset {
  id: string;
  image_file_name: string;
  image_url: string;
  asset_type: string;
  file: File | null;
  declined_reason: string;
  record_type: string;
  record_id: string;
  keepInLocal: boolean;

  constructor(
    id: string,
    image_file_name: string,
    image_url: string,
    asset_type: string,
    file?: File,
    declined_reason?: string,
    record_type?: string,
    record_id?: string,
    keepInLocal?: boolean
  ) {
    this.id = id;
    this.image_file_name = image_file_name;
    this.image_url = image_url;
    this.asset_type = asset_type;
    this.file = file || null;
    this.declined_reason = declined_reason || '';
    this.record_type = record_type || '';
    this.record_id = record_id || '';
    this.keepInLocal = keepInLocal || false;
  }
}
